import { Print } from "@mui/icons-material";
import { IconButton, Box } from "@mui/material";

import { SaveButtonSuite } from "components/SaveButtonSuite";
import { Tooltip } from "components/Tooltip";
import { CloseX } from "components/utility/CloseX";
import { ModalTitle } from "components/utility/ModalTitle";

import { i18n } from "services/i18nService";
import { checkForUnexpectedProps } from "services/utility/misc";

const iconButtonSx = {
  padding: "0.4rem",
  height: "36px",
  border: "1px solid",
  borderColor: "lineSeparatorMinor",
  backgroundColor: "white",
  borderRadius: 1,
};

export function ConfirmationModalHeader(props) {
  const { record, setErrors, errors, handleClose, rates, ...unexpected } =
    props;
  checkForUnexpectedProps("EditModalHeader", unexpected);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "dialogTitleBackground",
          borderBottom: "1px solid",
          borderBottomColor: "lineSeparatorMinor",
          padding: "0.5rem 1rem",
          fontSize: "1.2rem",
        }}
      >
        <div
          style={{
            display: "grid",
            alignItems: "top",
            gridTemplateColumns: `1fr 1fr`,
          }}
        >
          <div style={{ minWidth: "0" }}>
            <div style={{ display: "flex", alignItems: "top" }}>
              <CloseX onClick={handleClose} dataTesting="exitEdit" />
              <ModalTitle
                pl={1}
                label={i18n("upsShipment.ConfirmUpsShipment")}
              />
            </div>
          </div>

          <Box sx={{ displayPrint: "none" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Tooltip placement="bottom-start" title={i18n("global.Print")}>
                <IconButton
                  onClick={() => window.print()}
                  sx={iconButtonSx}
                  size="large"
                >
                  <Print />
                </IconButton>
              </Tooltip>
              <SaveButtonSuite
                objectType="upsshipment"
                record={record}
                setErrors={setErrors}
              />
            </Box>
          </Box>
        </div>
      </Box>
    </>
  );
}
